var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"on-resize",rawName:"v-on-resize"}],staticClass:"video-maker-vue"},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }